function NotFound() {
  return <h1>Error 404 Page not Found</h1>;
}

export default NotFound;
